import { gql } from 'apollo-boost';

export const UPDATE_ARTIFACT_USER_STATE = gql`
    mutation($data: UpdateArtifactUserStateInput!) {
        updateArtifactUserState(data: $data) {
            id
            artifact
            user
            status
            contextTags
            checkedEntryIds
            rating
            notes
            completedAt
            updatedAt
        }
    }
`;
